import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Martín R.',
  location: 'Buenos Aires',
  text: 'Nunca había estampado nada y con este sistema logré mi primera remera en un fin de semana. Increíble lo claro que está todo.'
}, {
  name: 'Lucía G.',
  location: 'Córdoba',
  text: 'Arranqué vendiendo remeras personalizadas y ya recuperé la inversión del kit en la primera semana.'
}, {
  name: 'Diego F.',
  location: 'Rosario',
  text: 'Probé tutoriales de YouTube y siempre me salía mal. Con este método entendí todo de una. Lo recomiendo 100%.'
}];
export function TestimonialsSection() {
  return <section className="py-12 bg-dark relative" data-id="element-217">
      <div className="container mx-auto px-4" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-219">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-220">
            MIRÁ LO QUE DICEN QUIENES{' '}
            <span className="text-accent-yellow" data-id="element-221">YA EMPEZARON</span>
          </h2>
          <div className="w-24 h-1 bg-accent-yellow mx-auto rounded-full" data-id="element-222" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-6xl mx-auto" data-id="element-223">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-card p-6 rounded-2xl border border-white/10 relative" data-id="element-224">
              <Quote className="absolute top-5 right-5 w-10 h-10 text-white/5" data-id="element-225" />

              <div className="flex gap-1 mb-4" data-id="element-226">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-accent-yellow text-accent-yellow" data-id="element-227" />)}
              </div>

              <p className="text-gray-300 text-base mb-6 italic" data-id="element-228">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-229">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-accent-pink to-accent-cyan flex items-center justify-center text-white font-bold text-xl" data-id="element-230">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-231">
                  <h4 className="font-bold text-white text-lg" data-id="element-232">
                    {testimonial.name}
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-233">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}